import { type IHoliday } from "@/interfaces/api/holiday.interface"
import { BaseRepository } from "@/repositories/base-repository"

export class HolidayRepository extends BaseRepository<IHoliday> {
  resourcePath = "planning/holidays"
}
